module.exports = __webpack_public_path__ + "static/fonts/PorscheNextWCy-Thin.8804fc30.woff";